<template>
  <section class="video-module" v-if="content.video_src">
    <div class="headline">{{content.video_headline}}</div>
    <div class="video">
      <video
        :src="content.video_src.data.full_url"
        ref="videoEl"
        @playing="onPlaying"
        @pause="onPause"
      ></video>
      <div class="video__controls" @click="onPlayPauseClick">
        <img src="../assets/play-icon.svg" v-if="!playing" class="video__play" />
        <img src="../assets/pause-icon.svg" v-if="playing" class="video__pause" />
      </div>
    </div>
  </section>
</template>


<script>
export default {
  props: {
    currentVideo: {
      type: HTMLVideoElement
    },
    content: {
      type: Object
    }
  },
  data() {
    return {
      playing: false,
      videoEl: null
    };
  },

  methods: {
    onPlayPauseClick() {
      if (this.$refs.videoEl.paused) {
        if (this.currentVideo) this.currentVideo.pause();
        this.$refs.videoEl.play();
        this.$emit("play", this.$refs.videoEl);
      } else {
        this.$refs.videoEl.pause();
        this.$emit("pause", this.$refs.videoEl);
      }
    },
    onPlaying() {
      this.playing = true;
    },
    onPause() {
      this.playing = false;
    }
  }
};
</script>